export { addGlobalEventProcessor, Scope } from './scope';
export { getCurrentHub, getHubFromCarrier, getMainCarrier, Hub, makeMain, setHubOnCarrier } from './hub';
export { Span, TRACEPARENT_REGEXP } from './span';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@sentry/hub/esm/index.js
// module id = cypG
// module chunks = 22